module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/modal//pet-bg.png?v=ec929432";